import { Flex } from '@revenuemarket/cds';
import { semanticColors } from '@revenuemarket/design';
import { IHeaderParams } from 'ag-grid-community';
import { Typography } from 'antd';

const HeaderRenderer = (props: IHeaderParams & { alertText?: string }) => {
  return (
    <Flex align="center" gap={4}>
      <Typography.Text
        style={{
          fontWeight: 'bold',
        }}
      >
        {props.displayName}
      </Typography.Text>
      {props.alertText && (
        <Typography.Text style={{ color: semanticColors.danger.medium, fontSize: 12 }}>
          {props.alertText}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default HeaderRenderer;
